import {BACKEND} from '../../consts/backend';

const GetDestinationTypes = async () => {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  const resp = await fetch(
    `${BACKEND}/destinationtype`,
    requestOptions
  );
  const sku = await resp.json();

  return sku;
};

export default GetDestinationTypes;
